<template>
  <div class="table">
    <el-table id="iTable" v-loading.iTable="options.loading" :data="list" :height="height" :stripe="options.stripe"
      ref="mutipleTable" :border="options.border">
      <el-table-column v-if="options.serialNumber" type="index" :label="$t('HomPage.MasterKong.rank')" align="center"
        :index="indexMethod" width="80">
        <template slot-scope="scope">
          <div style="text-align: center;" :style="{background: 'url('+scope.row.imgPath+') no-repeat 50% 50%'}">{{ scope.row.rank }}</div>
        </template>
      </el-table-column>
      <template v-for="(column, index) in columns">
        <el-table-column :prop="column.prop" :key="column.label" :label="column.label" :align="column.align"
          :width="column.width" :sortable="column.sortable" :fixed="column.fixed">
          <template slot-scope="scope">
            <template v-if="!column.render">
              <template v-if="column.formatter">
                <span v-html="column.formatter(scope.row, column)"></span>
              </template>
              <template v-else>
                <span>{{ scope.row[column.prop] }}</span>
              </template>
            </template>
            <template v-else>
              <expand-dom :column="column" :row="scope.row" :render="column.render" :index="index"></expand-dom>
            </template>
          </template>
        </el-table-column>
      </template>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    height: {
      type: [Number, String, Function],
      default: () => null,
    },
    list: {
      type: Array,
      default: () => {
        return [];
      },
    },
    columns: {
      type: Array,
      default: () => {
        return [];
      },
    },
    reserve: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Object,
      default: {
        stripe: false,
        border: false,
        highlightCurrentRow: false,
      },
    },
  },

  components: {
    expandDom: {
      functional: true,
      props: {
        row: Object,
        render: Function,
        index: Number,
        column: {
          type: Object,
          default: null,
        },
      },
      render: (h, ctx) => {
        const params = {
          row: ctx.props.row,
          index: ctx.props.index,
        };
        if (ctx.props.column) params.column = ctx.props.column;
        return ctx.props.render(h, params);
      },
    },
  },

  data() {
    return {
      pageIndex: 1,
      dtatus: "",
    };
  },
  computed: {},
  methods: {
    indexMethod(index) {
      return index * 1 + 1;
    },

    isEmpty() {
      this.$refs.mutipleTable.clearSelection();
    },

    checkboxInit(row, index) {
      if (this.dtatus == row.status) {
        return true;
      } else if (this.dtatus == "") {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.table {
  /deep/.el-table {
    background-color: #081831;

    th {
      font-size: 14px;
      color: #F0F8FF;
      background-color: #0E4273 !important;
      padding: 0;
      height: 28px;
      line-height: 28px;
      border-bottom: none;
    }

    tr {
      height: 25px;
      line-height: 25px;
    }

    td,
    th.is-leaf {
      //  border-bottom: 4px solid #0E4273;
    }

    tr.el-table__row--striped td.el-table__cell {
      background-color: #0A2546;
      border-bottom: none;
    }

    tr:hover>td {
      background-color: #081831;
    }

    td {
      font-size: 12px;
      color: #F0F8FF;
      padding: 0;
      background-color: #081831;
      border-bottom: none;

      .el-tag {
        background-color: transparent;
        font-size: 12px;
        height: 20px;
        line-height: 20px;
        border: none !important;
      }
    }
  }

  .el-table::before {
    height: 0;
  }

  .el-table--border td {}
}
</style>
